// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentCaseOrderedRelationshipModel {
    static getAttributeTypeMap() {
        return EnrollmentCaseOrderedRelationshipModel.attributeTypeMap;
    }
}
EnrollmentCaseOrderedRelationshipModel.discriminator = undefined;
EnrollmentCaseOrderedRelationshipModel.attributeTypeMap = [
    {
        "name": "coverageOrder",
        "baseName": "coverageOrder",
        "type": "number"
    },
    {
        "name": "partyRoleId",
        "baseName": "partyRoleId",
        "type": "number"
    },
    {
        "name": "isPrimary",
        "baseName": "isPrimary",
        "type": "boolean"
    }
];
//# sourceMappingURL=enrollmentCaseOrderedRelationshipModel.js.map